/* eslint-disable */
import React, { useMemo, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Select, Row, Col } from 'antd';
import PropTypes from 'prop-types';

import CustomModal from '../common/modals/CustomModal';
import ProfileAvatar from '../common/ProfileAvatar';
import OnTraccrButton from '../common/buttons/OnTraccrButton';
import DisplayText from '../common/text/DisplayText';

import colors from '../constants/Colors';

const warningText = 'Warning: This action cannot be undone. If you need ownership back, this setting will have to be updated by the new owner.'

const getAdminUsers = (users = []) => {
  const adminUsers = [];
  users.forEach((user) => {
    if (user.position.toLowerCase() === 'admin') {
      adminUsers.push(user);
    }
  });
  return adminUsers;
};

function CompanyOwnerModal({
  visible,
  onCloseClicked,
  afterClose,
  onSubmit
}) {
  const users = useSelector((state) => state.users.users);
  const adminUsers = useMemo(() => getAdminUsers(users), [users]);
  
  const [selected, setSelected] = useState();

  useEffect(() => {
    if (!visible) {
      setSelected();
    }
  }, [visible])

  return (
    <CustomModal
      title={'Transfer Ownership'}
      visible={visible}
      onCloseClicked={onCloseClicked}
      afterClose={afterClose}
      maskColor={'#00000073'}
    >
      <div style={{
        width:'100%',
        padding:20,
      }}>
        <Select
          className='OnTraccrSelect'
          key='company-owner-select'
          style={{ width: '100%' }}
          placeholder='Select new owner'
          onChange={setSelected}
          optionLabelProp='label'
          showSearch
          optionFilterProp='label'
          value={selected}
        >
          {adminUsers.map((item) => 
            <Select.Option key={item.id} value={item.id} label={item.name}>
              {
                <ProfileAvatar key={item.id} {...{...item,role:item.position}} style={{ marginTop:2, marginBottom:2,}}/>
              }
          </Select.Option>)}
        </Select>
        <Row type='flex' style={{ width: '100%', marginTop: 15}}>
          <DisplayText title={warningText} style={{
            fontFamily: 'roboto-bold', 
            fontSize:14,
            color: colors.ONTRACCR_TITLE_BLACK
          }}/>
        </Row>
        <Row type='flex' justify='center' gutter={16} style={{
            width:'100%',
            marginTop:15
          }}>
          <Col>
            <OnTraccrButton
              title='Cancel'
              onClick={onCloseClicked}
              type='cancel'
              />
          </Col>
          <Col>
            <OnTraccrButton 
              title='Confirm'
              disabled={!selected}
              onClick={() => onSubmit(selected)}
              type='primary'
              />
          </Col>
        </Row>
      </div>
    </CustomModal>
  );
}

CompanyOwnerModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCloseClicked: PropTypes.func.isRequired,
  afterClose: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  canSubmit: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default CompanyOwnerModal;
